import s from '_Charts/KpisCharts/KpiBadges/style.scss';

export function capitalize(string) {
  return s && string[0].toUpperCase() + string.slice(1);
}
